<template lang="pug">
.home
  .img-div
  .content
    .content-div
      .content-div-title
        h1 Hey you,
        h1 nice meeting you! I'm Andy 😀
      .content-div-item
        .content-div-item-img
          .content-div-item-img-im.university
        .content-div-item-p
          p I’m studying Robotics, Cognition, Intelligence at TUM and am currently working on my Master’s Thesis on Unsupervised Domain Adaptation for Lane Detections at MIT/TUM.
      .content-div-item
        .content-div-item-img
          .content-div-item-img-im.code
        .content-div-item-p
          p At IBM I have been working lots on fullstack development, especially using VueJS and NestJS. Furthermore, during my studies, I have worked on Computer Vision and Deep Learning projects using Python and C++.
      .content-div-item
        .content-div-item-img
          .content-div-item-img-im.music
        .content-div-item-p
          p I love to make music! I play the piano, bass and guitar and am in the band Springstories. Feel free to check out our latest song 
            a(href="https://www.youtube.com/watch?v=vrpscFgayKs" target="_blank") here.
      .content-div-item
        .content-div-item-img
          .content-div-item-img-im.restaurant
        .content-div-item-p
          p Cooking is a huge passion of mine! Currently, I really enjoy making vegetarian dishes in the style of the Indian cuisine!
      .content-div-item
        .content-div-item-img
          .content-div-item-img-im.coffee
        .content-div-item-p
          p Continuous learning is one of my core values which is why I’m always curious getting to know new and interesting people. Feel free to connect with me on my socials, pop a message into my inbox or just directly set a 
            a(href="https://calendly.com/andychen1996/30min" target="_blank") meeting with me.
    .content-div-bottom
      .content-div-bottom-div
        .content-div-bottom-div-top
          a(href="https://github.com/andy-96" target="_blank").content-div-bottom-div-top-img.github
          a(href="https://linkedin.com/in/andychen1996" target="_blank").content-div-bottom-div-top-img.linkedin
          a(href="https://instagram.com/__andy96/" target="_blank").content-div-bottom-div-top-img.instagram
          a(href="mailto:mail@andychen.de" target="_blank").content-div-bottom-div-top-img.email
        .content-div-bottom-div-bottom
          a(href="")
            p imprint
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style lang="sass">
@import url("https://fonts.googleapis.com/css2?family=PT+Serif&display=swap")

.home
  @media only screen and (min-width: 750px)
    display: flex

  .img-div
    flex: 1
    background-color: #aaa
    height: 50vh
    @media only screen and (min-width: 750px)
      height: 100vh
    background-image: url("../assets/IMG_20210824_171401_809_small.jpg")
    background-size: cover
    background-position: center

  .content
    flex: 2
    background-color: #EBD6B7
    filter: drop-shadow(-10px 0px 10px rgba(0, 0, 0, 0.25))
    height: 850px
    @media only screen and (min-width: 750px)
      height: 100vh

    &-div
      margin: 0 10% 5% 10%
      padding-top: 5%
      @media only screen and (min-width: 750px)
        padding-top: 0
        margin: 5% 10% 5% 10%

      h1
        margin: 0 0 0.5rem 0
        @media only screen and (max-width: 750px)
          font-size: 1.2rem
          margin-bottom: 0


      &-title
        margin-bottom: 2rem

      &-item
        display: flex
        height: 100px
        width: 100%
        margin-bottom: 1rem

        &-img
          position: relative
          width: 2.5rem
          @media only screen and (min-width: 750px)
            width: 6rem

          &-im
            top: 50%
            transform: translateY(-50%)
            position: absolute
            width: 2rem
            height: 2rem
            @media only screen and (min-width: 750px)
              width: 4rem
              height: 4rem
            background-size: cover
            background-position: center
            opacity: 0.8 !important

          .university
            background-image: url("../assets/university.png")

          .code
            background-image: url("../assets/coding.png")

          .music
            background-image: url("../assets/music.png")
          
          .restaurant
            background-image: url("../assets/restaurant.png")
          
          .coffee
            background-image: url("../assets/coffee.png")

        &-p
          position: relative
          width: 100%

          p
            top: 50%
            transform: translateY(-50%)
            position: absolute
            font-size: 0.9rem
            @media only screen and (min-width: 750px)
              font-size: 1rem
            font-family: "PT Serif"
            margin: 0 0 0 2rem

          a
            color: #433C31

      &-bottom
        position: absolute
        bottom: 0
        width: 100%
        height: 80px
        left: 50%

        &-div
          &-top
            transform: translateX(-50%)
            width: 200px
            display: flex
            justify-content: space-between

            &-img
              height: 1.5rem
              width: 1.5rem
              opacity: 0.8
              background-size: cover
              background-position: center
              &:hover
                opacity: 0.4

            .github
              background-image: url("../assets/github.png")

            .linkedin
              background-image: url("../assets/linkedin.png")

            .instagram
              background-image: url("../assets/instagram.png")

            .email
              background-image: url("../assets/email.png")

          &-bottom
            p
              color: #433C31
              font-size: 0.9rem
              @media only screen and (max-width: 750px)
                font-size: 0.7rem
              margin-top: 0.8rem
              opacity: 0.8
              width: min-content
              transform: translateX(-50%)
</style>
